import { postAdmin } from "../axios/api/AdminBaseUrl"

export const auth ={
    login:{
        key:"login",
        call:(payload)=>{
            return postAdmin("/auth/login/",payload)
        }
    },
    forgotpassword:{
        key:"forgotpassword",
        call:(payload)=>{
            return postAdmin("/auth/forgot_password/",payload)
        }
    },  resetpassword:{
        key:"resetpassword",
        call:(payload,id,token)=>{
            return postAdmin(`/auth/reset_password/${id}/?token=${token}`,payload)
        }
    },
    setpassword:{
        key:"setpassword",
        call:(payload,id,token)=>{
            return postAdmin(`/auth/set_new_password/${id}/?token=${token}`,payload)
        }
    },

}
